import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import SearchIcon from "../../assets/icons/search.svg";
import Sidebar from "../../Components/partials/Sidebar";
import Header from "../../Components/partials/Header2";
import { useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { motion } from "framer-motion";
import HashLoader from "react-spinners/ClipLoader";
import BackIcon from "../../images/icon-back.png";
import Images from "../modal/Images";
import { Link, useNavigate, useParams } from "react-router-dom";
const GameDetails = () => {
  const url = process.env.REACT_APP_APP_BACK_URL;
  const { id } = useParams();
  const [data, setData] = useState([]);
  const isAuthenticated = useSelector((state) => state.user);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10;
  const [isNotFound, setIsNotFound] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);
  const [isImageLarge, setIsImageLarge] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [credentials, setCredentials] = useState({ status: "all", name: "" });
  const handleInput = (e) => {
    setCurrentPage(1);
    setCredentials((prevCredentials) => {
      const updatedCredentials = {
        ...prevCredentials,
        [e.target.name]: e.target.value,
      };
      fetchData(updatedCredentials);
      return updatedCredentials;
    });
  };
  useEffect(() => {
    fetchData(credentials);
  }, [currentPage]);
  const fetchData = async (fetchCredentials) => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      setIsLoading(true);
      setIsDisplay(false);
      setIsNotFound(false);
      const response = await fetch(
        `${url}/api/prizes/games/details/${id}?page=${currentPage}&limit=${itemsPerPage}&status=${fetchCredentials.status}`,
        {
          mode: "cors",
          method: "GET",
          headers: headers,
        }
      );
      setIsLoading(false);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      if (json.prizes.length > 0) {
        setIsDisplay(true);
        setData(json.prizes);
      } else {
        setIsNotFound(true);
      }
      setTotalPages(json.totalPages);
    } catch (error) {
      console.error(error);
    }
  };
  const handleResetBtn = () => {
    const updatedCredentials = {
      name: "",
      status: "all",
    };
    // Update state and then call fetchData
    setCredentials(updatedCredentials);
    setCurrentPage(1);
    // Call fetchData with the updated credentials
    fetchData(updatedCredentials);
  };
  const handleDelete = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        reverseButtons: true,
      });
      if (result.isConfirmed) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Access-Control-Allow-Origin", "*");
        headers.append("Access-Control-Allow-Credentials", "true");
        const response = await fetch(`${url}/api/prizes/delete/${id}`, {
          mode: "cors",
          method: "DELETE",
          headers: headers,
        });
        if (response.ok) {
          fetchData(credentials); // Refresh the records list after successful deletion
          Swal.fire("Deleted!", "Site deleted successfully!", "success");
        } else {
          Swal.fire(
            "Error",
            "An error occurred while deleting the record.",
            "error"
          );
        }
      }
    } catch (error) {
      console.log("Error deleting record:", error);
      Swal.fire(
        "Error",
        "An error occurred while deleting the record.",
        "error"
      );
    }
  };
  const handlePennding = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You wont to approve this transaction!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, approve it!",
        cancelButtonText: "No, cancel",
        reverseButtons: true,
      });
      if (result.isConfirmed) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Access-Control-Allow-Origin", "*");
        headers.append("Access-Control-Allow-Credentials", "true");
        const response = await fetch(
          `${url}/api/prizes/approve/transaction/${id}`,
          {
            mode: "cors",
            method: "GET",
            headers: headers,
          }
        );
        if (response.ok) {
          fetchData(credentials); // Refresh the records list after successful deletion
          Swal.fire(
            "Approved!",
            "Transaction approved successfully!",
            "success"
          );
        } else {
          Swal.fire(
            "Error",
            "An error occurred while approved the transaction.",
            "error"
          );
        }
      }
    } catch (error) {
      Swal.fire(
        "Error",
        "An error occurred while approved the transaction.",
        "error"
      );
    }
  };
  const handleApproved = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You wont to update this transaction!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, update it!",
        cancelButtonText: "No, cancel",
        reverseButtons: true,
      });
      if (result.isConfirmed) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Access-Control-Allow-Origin", "*");
        headers.append("Access-Control-Allow-Credentials", "true");
        const response = await fetch(
          `${url}/api/prizes/pennding/transaction/${id}`,
          {
            mode: "cors",
            method: "GET",
            headers: headers,
          }
        );
        if (response.ok) {
          fetchData(credentials); // Refresh the records list after successful deletion
          Swal.fire(
            "Pennding!",
            "Transaction  updated successfully!",
            "success"
          );
        } else {
          Swal.fire(
            "Error",
            "An error occurred while updated the transaction.",
            "error"
          );
        }
      }
    } catch (error) {
      Swal.fire(
        "Error",
        "An error occurred while approved the transaction.",
        "error"
      );
    }
  };
  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1); // react-paginate uses zero-based indexing
  };
  const formattedDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
  const toggleImageSize = () => {
    setIsImageLarge(!isImageLarge);
  };
  const openModal = (imageUrl) => {
    setSelectedImageUrl(imageUrl);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImageUrl("");
  };
  function toggleFilterSection() {
    setIsFilterVisible(!isFilterVisible);
  }
  const [isActive, setIsActive] = useState(false);
  // Function to toggle the active state
  const toggleActive = () => {
    setIsActive(!isActive);
  };
  // Define the CSS classes based on the isActive state
  const divClassName = isActive ? "sidebar active" : "sidebar";
  return (
    <div className={styles.heading}>
      <div className="body-wrap">
        <section className={styles.sidebar_wrap}>
          <div className="container-fluid px-0">
            <div className="d-flex">
              <Sidebar />
              <div className="p-3 w-100 main__content">

                <Header isActive={isActive} toggleActive={toggleActive} />
                <div className="general-dashboard">
                  <div className="container-fluid">
                    <div className="mb-3">
                      <div className="row">
                        <div className="col-lg-6 my-auto">
                          <div className="user-wrap user-back-wrap">
                            <Link to="/user/list">
                              <div className="back-icon">
                                <img src={BackIcon} alt="" />
                              </div>
                            </Link>
                            <div className="user-wrap">
                              <h3>Prizes</h3>
                              <p>List of all the prizes user win</p>
                            </div>
                          </div>

                        </div>
                        <div className="col-lg-6 text-end">
                          <div className="filter-right-sec">
                            <div className="filter-wrap">
                              <div
                                className="filter-box"
                                onClick={toggleFilterSection}
                              >
                                <i className="fas fa-filter" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {isFilterVisible && (
                        <>
                          <motion.div
                            className={`row mt-5 filter-section`}
                            initial={{ opacity: 0 }} // Initial state (hidden)
                            animate={{ opacity: isFilterVisible ? 1 : 0 }} // Animate opacity based on isFilterVisible
                            transition={{ duration: 1.2, delay: 0.1 }}
                          >
                            <div className="col-12">
                              <div className="filter-right-sec filter-wrap-chat">
                                <div className="filter-select d-flex align-items-center">
                                  <label htmlFor="">TransactionStatus</label>
                                  <select
                                    name="status"
                                    id=""
                                    value={credentials.status}
                                    onChange={handleInput}
                                  >
                                    <option value="all">Choose Status</option>
                                    <option value="pendding">Pennding</option>
                                    <option value="approved">Approved</option>
                                  </select>
                                </div>
                                <Link
                                  to=""
                                  onClick={handleResetBtn}
                                  className="btn btn-prim w-auto"
                                >
                                  RESET
                                </Link>
                              </div>
                            </div>
                          </motion.div>
                        </>
                      )}
                    </div>
                    {/* row */}
                    <div className="table-wrap">
                      <div className="row">
                        <div className="col-12">
                          <div className={styles.card_box}>
                            <div className={styles.tables_wrap}>
                              <div className="table-responsive">
                                <table className="table align-middle">
                                  <thead>
                                    <tr>
                                      <th>winer name</th>
                                      <th>score</th>
                                      <th>amount</th>
                                      <th>date</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {isLoading && (
                                      <>
                                        <tr>
                                          <td
                                            colSpan={5}
                                            className="text-center"
                                            style={{
                                              background: "transparent",
                                            }}
                                          >
                                            <HashLoader
                                              color={`#0b0d41`}
                                              loading={isLoading}
                                              size={40}
                                              aria-label="Loading Spinner"
                                              data-testid="loader"
                                            />
                                          </td>
                                        </tr>
                                      </>
                                    )}
                                    {isDisplay &&
                                      data.map((item, i) => (
                                        <motion.tr
                                          key={item._id}
                                          initial={{ opacity: 0 }}
                                          animate={{ opacity: 1 }}
                                          transition={{
                                            duration: 1.2,
                                            delay: i * 0.1,
                                          }}
                                        >
                                          <td>{item.winer_name}</td>
                                          <td>
                                            <span className="status success">
                                              {item.score}
                                            </span>
                                          </td>
                                          <td>
                                            {item.type === "money" && "$"}
                                            {item.amount}
                                          </td>
                                          <td>
                                            {formattedDate(item.createdAt)}
                                          </td>
                                          <td>
                                            {item.transaction_status ===
                                              "pendding" && (
                                                <button
                                                  type="button"
                                                  className="btn btn-edit tb-btn"
                                                  onClick={() =>
                                                    handlePennding(item._id)
                                                  }
                                                >
                                                  Pending
                                                </button>
                                              )}
                                            {item.transaction_status ===
                                              "approved" && (
                                                <button
                                                  type="button"
                                                  className="btn btn-success tb-btn"
                                                  onClick={() =>
                                                    handleApproved(item._id)
                                                  }
                                                >
                                                  Approved
                                                </button>
                                              )}
                                          </td>
                                        </motion.tr>
                                      ))}
                                    {isNotFound && (
                                      <tr>
                                        <td colSpan={6} className="text-center" style={{ color: "red" }}>
                                          No Data Found
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                              <div className="table-num">
                                {data.length > 0 && (
                                  <ReactPaginate
                                    previousLabel={"<"}
                                    nextLabel={">"}
                                    breakLabel={"..."}
                                    pageCount={totalPages}
                                    forcePage={currentPage - 1} // react-paginate uses zero-based indexing
                                    onPageChange={handlePageChange}
                                    containerClassName={" dig-num"}
                                    pageClassName={"dig-num"}
                                    previousClassName={"num-btns"}
                                    nextClassName={"num-btns"}
                                    disabledClassName={"pagination-disabled"}
                                    activeClassName={"pagination-active"}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
export default GameDetails;
